import CheckBoxIcon from "@mui/icons-material/CheckBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

/** Thin outline matching MUI CheckBoxOutlineBlank outer bounds (14×14 in 24 viewBox). */
export function RegulationsTableCheckboxOutlineIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <rect
        x="5"
        y="5"
        width="14"
        height="14"
        rx="0.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
      />
    </SvgIcon>
  );
}

export const REGULATIONS_TABLE_BASE_CHECKBOX_SLOT_PROPS = {
  icon: <RegulationsTableCheckboxOutlineIcon />,
  checkedIcon: <CheckBoxIcon />,
  indeterminateIcon: <IndeterminateCheckBoxIcon />,
  sx: {
    color: "#d9d9d9",
    "&.Mui-checked, &.MuiCheckbox-indeterminate": {
      color: "primary.main",
    },
  },
} as const;
